import { CloseOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Divider, Flex, Form, Input, Switch, Typography } from "antd";
import React from "react";

interface PointOfContactFieldsProps {
  namePath: (string | number)[];
}

const PointOfContactFields: React.FC<PointOfContactFieldsProps> = ({
  namePath,
}) => {
  return (
    <>
      <Typography.Text
        style={{ paddingBottom: 8, display: "block", fontWeight: 500 }}
      >
        Point of contact
      </Typography.Text>
      <Form.List name={namePath}>
        {(fields, { add, remove }) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 32,
            }}
          >
            {fields.map((field, index) => (
              <div key={`poc_${field.name}`}>
                {index > 0 && (
                  <div
                    style={{
                      display: "flex",
                      marginBottom: 20,
                      flexDirection: "column",
                    }}
                  >
                    <Divider style={{ borderColor: "#05050521" }} />
                    <Flex justify="space-between">
                      <span style={{ fontWeight: 500, fontSize: ".9rem" }}>
                        Aditional Contact
                      </span>
                      <CloseOutlined
                        onClick={() => {
                          remove(field.name);
                        }}
                      />
                    </Flex>
                  </div>
                )}
                <Form.Item name={[field.name, "name"]}>
                  <Input placeholder="First name" />
                </Form.Item>
                <Form.Item name={[field.name, "email"]} noStyle>
                  <Input type="email" placeholder="Email" />
                </Form.Item>
                <div
                  style={{
                    backgroundColor: "#F9F5ED",
                    marginBottom: 24,
                    height: 40,
                    marginTop: -4,
                    borderRadius: "0 0 6px 6px",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #E6E6E6",
                    padding: "8px 16px",
                    gap: 8,
                  }}
                >
                  <Form.Item
                    name={[field.name, "notifyEmail"]}
                    noStyle
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                  Send login information to email
                </div>
                <Form.Item name={[field.name, "phone"]} noStyle>
                  <Input placeholder="Phone number" />
                </Form.Item>
                <div
                  style={{
                    backgroundColor: "#F9F5ED",
                    height: 40,
                    marginTop: -4,
                    borderRadius: "0 0 6px 6px",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #E6E6E6",
                    padding: "8px 16px",
                    gap: 8,
                    lineHeight: 1.1,
                  }}
                >
                  <Form.Item
                    name={[field.name, "includeCollabs"]}
                    noStyle
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                  Include in notifications about collabs
                </div>
              </div>
            ))}

            <Flex style={{ marginTop: 24 }}>
              <span
                style={{ color: "#1D2023", cursor: "pointer", fontWeight: 500 }}
                onClick={() => add()}
              >
                <PlusCircleOutlined style={{ marginRight: 4 }} />
                Add another POC
              </span>
            </Flex>
          </div>
        )}
      </Form.List>
    </>
  );
};

export default PointOfContactFields;
export type { PointOfContactFieldsProps };
